import { h, render } from "preact";

export default function CompareBuyCta({ compareProduct }) {
  return (
    <div className="compare-modal-v2__row-item compare-modal-v2__buy-cta-wrapper">
      <div className="compare-modal-v2__buy-cta-price">
        {window
          .formatMoney(compareProduct.product.priceRange.minVariantPrice.amount)
          .replace(/\.00$/, "")}
      </div>
      <a
        href={compareProduct.product.onlineStoreUrl}
        class="compare-modal-v2__buy-cta button button--black"
      >
        Buy Now
      </a>
    </div>
  );
}
